import {
  GET_USER_PROFILE_DICTIONARY_REQUEST,
  GET_USER_PROFILE_DICTIONARY_SUCCESS,
  GET_USER_PROFILE_DICTIONARY_FAILURE,
} from '../constants/ActionTypes';

const initialState = {
  error: null,
  isLoading: false,
  vacancies: [],
};

export default function authUserReducer(
  state = initialState,
  { type, payload },
) {
  switch (type) {
    case GET_USER_PROFILE_DICTIONARY_REQUEST: {
      return {
        ...state,
        isLoading: payload.isLoading,
      };
    }
    case GET_USER_PROFILE_DICTIONARY_SUCCESS: {
      return {
        ...state,
        profileDictionary: payload.profileDictionary,
      };
    }
    case GET_USER_PROFILE_DICTIONARY_FAILURE: {
      return {
        ...state,
        error: payload.error,
      };
    }
    default: {
      return state;
    }
  }
}
